import { css } from 'styled-components';
import { getFontFormatURLs } from "./fonts";
import { responsiveBodyMD, responsiveBodySM, responsiveBodyXS, responsiveHeadingLG, responsiveHeadingMD, responsiveHeadingSM, responsiveHeadingXL, responsiveHeadingXS } from "./responsiveFontSizes";
import { colors } from "../constants/colors";

/** @deprecated use new brand color variables */
var themeColors = {
  /** @deprecated */blueNavy: colors.brandBluePrimary,
  /** @deprecated */bluePattens: colors.brandBlueLight,
  /** @deprecated */blueAlice: colors.neutralLighter,
  /** @deprecated */brandBlueDarker: colors.brandBlueDark,
  /** @deprecated */brandPurplePrimary: colors.brandBlueLight,
  /** @deprecated */functionalRedPrimary: colors.functionalRedPrimary,
  /** @deprecated */neutralDark: colors.neutralDark,
  /** @deprecated */neutralDarker: colors.neutralDarker,
  /** @deprecated */neutralLight: colors.neutralLight,
  /** @deprecated */redMandy: '#c94a55',
  /** @deprecated */redPrimary: colors.functionalRedPrimary,
  /** @deprecated */purpleDeluge: '#7f6ca7',
  /** @deprecated */greySlate: colors.neutralPrimary,
  /** @deprecated */greyGeyser: colors.neutralLight,
  /** @deprecated */blackPearl: colors.neutralDarker,
  /** @deprecated */white: colors.neutralWhite
};

/** @deprecated use responsive font sizes variables */
var designSystemFontSizes = {
  HEADING: {
    /** @deprecated */XL: {
      fontSize: 32,
      lineHeight: 40
    },
    /** @deprecated */LG: {
      fontSize: 28,
      lineHeight: 36
    },
    /** @deprecated */MD: {
      fontSize: 24,
      lineHeight: 32
    },
    /** @deprecated */SM: {
      fontSize: 20,
      lineHeight: 28
    },
    /** @deprecated */XS: {
      fontSize: 18,
      lineHeight: 32
    }
  },
  BODY: {
    /** @deprecated */MD: {
      fontSize: 16,
      lineHeight: 28
    },
    /** @deprecated */SM: {
      fontSize: 14,
      lineHeight: 24
    },
    /** @deprecated */XS: {
      fontSize: 12,
      lineHeight: 20
    }
  }
};
var responsiveFontSizes = {
  HEADING: {
    XL: responsiveHeadingXL,
    LG: responsiveHeadingLG,
    MD: responsiveHeadingMD,
    SM: responsiveHeadingSM,
    XS: responsiveHeadingXS
  },
  BODY: {
    MD: responsiveBodyMD,
    SM: responsiveBodySM,
    XS: responsiveBodyXS
  }
};
var BODY = designSystemFontSizes.BODY,
  HEADING = designSystemFontSizes.HEADING;
export var theme = {
  /** @deprecated use responsiveText */text: {
    /** @deprecated use responsiveText.HEADING */HEADING,
    /** @deprecated use responsiveText.BODY */BODY
  },
  responsiveText: {
    HEADING: responsiveFontSizes.HEADING,
    BODY: responsiveFontSizes.BODY
  },
  fonts: {
    PRIMARY_REGULAR: {
      family: 'NOTHS Sans No3',
      weight: 'normal',
      formats: getFontFormatURLs('fonts/noths_sans_3_regular')
    },
    PRIMARY_SEMIBOLD: {
      family: 'NOTHS Sans No3',
      weight: '600',
      formats: getFontFormatURLs('fonts/noths_sans_3_semibold')
    },
    SECONDARY_REGULAR: {
      family: 'NOTHS Sans No2',
      weight: 'normal',
      formats: getFontFormatURLs('fonts/noths_sans_2_regular')
    },
    SECONDARY_SEMIBOLD: {
      family: 'NOTHS Sans No2',
      weight: '600',
      formats: getFontFormatURLs('fonts/noths_sans_2_semibold')
    }
  },
  /** @deprecated */colors: themeColors,
  spacing: {
    base: 4,
    xs: 8,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 24,
    xxl: 32,
    xxxl: 48,
    xxxxl: 64
  }
};
export var primaryRegularFont = /*#__PURE__*/css(["font-family:", ";font-weight:", ";"], theme.fonts.PRIMARY_REGULAR.family, theme.fonts.PRIMARY_REGULAR.weight);
export var primarySemiBoldFont = /*#__PURE__*/css(["font-family:", ";font-weight:", ";"], theme.fonts.PRIMARY_SEMIBOLD.family, theme.fonts.PRIMARY_SEMIBOLD.weight);